import { render, staticRenderFns } from "./GestaoMenu.vue.js?vue&type=template&id=6b677af7!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GestaoMenu.vue?vue&type=template&id=6b677af7"
import script from "./GestaoMenu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GestaoMenu.vue?vue&type=script&lang=js"
export * from "./GestaoMenu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GestaoMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports